import { Tables } from "database.types";

export function sortGrades(grades: Tables<"grades">[]) {
  return [...grades].sort((a, b) => {
    return Number(b.id) - Number(a.id);
  });
}
